import React from "react";
import { Col, Row, Input, Button } from "reactstrap";
import moment from "moment";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { toFloat } from "validator";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EscrowRequestRefund from "./escrowRequestRefund";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const EscrowPaymentsTable = ({ tableData, searchQuery, defaultSorted, forceUpdate, setForce }) => {
  const { ExportCSVButton } = CSVExport;
  const { t } = useTranslation();

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format('YYYY-MM-DD')
    );
  };

  const amountFormatter = (cell, row) => (
    <b>{toFloat(cell).toFixed(0)} €</b>
  );

  const downloadFormatter = cell =>
    cell ? (
      <a href={cell} target="blank">
        <Button className="btn-status" color="primary">
          <b>{t("escrowWallet.view.escrowPayments.table.button.download")}</b>
        </Button>
      </a>
    ) : null;

  const refundProcessedFormatter = (cell, row) =>
    cell ?
    (
      <span className="p-4">
        <i className="fas fa-2x fa-check-circle text-success" id={`${row.id}`}></i>
      </span>
    ) :     
    (
      <span className="p-4">
        <i className="fas fa-2x fa-times-circle text-danger" id={`${row.id}`}></i>
      </span>
    );

  const requestRefundFormatter = (cell, row) => {
    return (
      <EscrowRequestRefund {...row} action={{forceUpdate, setForce}} />
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <Link to={`/e-wallet/payments/${row.id}/view/`} className="btn btn-outline-primary">{t("escrowWallet.view.escrowPayments.table.button.view")}</Link>
    );
  };

  const columns = [
    {
      dataField: "payment_id",
      text: t("escrowWallet.view.escrowPayments.table.column.paymentId"),
      sort: false,
      headerStyle: () => ({ width: "100px" }),
    },
    {
      dataField: "release_name",
      text: t("escrowWallet.view.escrowPayments.table.column.releaseName"),
      sort: false,
      headerStyle: () => ({ width: "100px" })
    },
    {
      dataField: "amount",
      text: t("escrowWallet.view.escrowPayments.table.column.amount"),
      formatter: amountFormatter,
      csvFormatter: amountFormatter,
      sort: false,
      headerStyle: () => ({ width: "60px" })
    },
    {
      dataField: "created",
      text: t("escrowWallet.view.escrowPayments.table.column.paymentDate"),
      formatter: dateFormatter,
      csvFormatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "80px" })
    },
    {
      dataField: "agreement_pdf",
      text: t("escrowWallet.view.escrowPayments.table.column.paymentAgreement"),
      formatter: downloadFormatter,
      csvFormatter: downloadFormatter,
      sort: false,
      headerStyle: () => ({ width: "80px" })
    },
    {
      dataField: "refund_processed",
      text: t("escrowWallet.view.escrowPayments.table.column.refundProcessed"),
      formatter: refundProcessedFormatter,
      sort: false,
      headerStyle: () => ({ width: "80px" })
    },
    {
      dataField: "refund_available",
      text: t("escrowWallet.view.escrowPayments.table.column.requestRefund"),
      formatter: requestRefundFormatter,
      sort: false,
      headerStyle: () => ({ width: "80px" })
    },
    {
      dataField: "details",
      text: t("escrowWallet.view.escrowPayments.table.column.details"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "40px" };
      }
    },
    {
      dataField: "release_name",
      sort: false,
      csvExport: false,
      hidden: true,
    }
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "created") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{ fileName: "escrow-payments.csv" }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                <Input
                  placeholder={t("escrowWallet.view.escrowPayments.table.placeholder.search")}
                  value={searchQuery.query}
                  style={{ marginBottom: 10 }}
                  onChange={e => searchQuery.setQuery(e.target.value)}
                />
              </div>
            </Col>

            <Col>
              <div className="flexEndContainer">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  {t("escrowWallet.view.escrowPayments.table.button.exportCsv")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            remote={{ sort: true }}
            defaultSorted={defaultSorted}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default EscrowPaymentsTable;